import React from 'react';
import { typography } from '@doer/frontend-components/theme';
import { headerTokens } from '@doer/frontend-components/platform-header';
import { getClientBrand } from 'src/clients/client-brand';

const CLIENT_LOGO_MAX_HEIGHT = Math.round(headerTokens.height * headerTokens.clientLogoMaxHeight);

interface ClientLogoProps {
  clientId?: string;
}

const { fontWeight, fontSize } = typography;

const gradientTextStyle: React.CSSProperties = {
  background: headerTokens.brandGradient,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  fontWeight: fontWeight.bold,
  fontSize: fontSize.xxl,
  lineHeight: 1,
  userSelect: 'none',
  display: 'flex',
  alignItems: 'center'
};

export const ClientLogo: React.FC<ClientLogoProps> = ({ clientId }) => {
  const [imgLoaded, setImgLoaded] = React.useState(false);
  const brand = getClientBrand(clientId);

  React.useEffect(() => {
    setImgLoaded(false);
  }, [brand?.logoUrl]);

  if (!brand) {
    return <div style={gradientTextStyle}>{clientId}</div>;
  }

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      {/* Fallback siempre visible hasta que la imagen cargue */}
      {!imgLoaded && <div style={gradientTextStyle}>{brand.displayName}</div>}
      <img
        src={brand.logoUrl}
        alt={brand.displayName}
        onLoad={() => setImgLoaded(true)}
        onError={() => setImgLoaded(false)}
        style={{
          maxHeight: CLIENT_LOGO_MAX_HEIGHT,
          width: 'auto',
          objectFit: 'contain',
          display: imgLoaded ? 'block' : 'none'
        }}
      />
    </div>
  );
};
